import _ from 'lodash';

function transformPrivileges(privileges, field = 'id') {
  return _.orderBy(privileges, ['id'], ['asc']).reduce((reduced, privilege) => _.set(reduced, privilege[field], privilege), {});
}

function createTree(privileges, field = 'displayPath') {
  const pathsArray = _.orderBy(privileges, ['displayPath'], ['asc']).map((privilege) => privilege[field].split('.'));
  const root = {};
  let node;
  let next;

  pathsArray.map((paths) => {
    const pathsString = paths.join('.');
    let tempPathsArray = [];
    const foundPrivilege = privileges.find((privilege) => privilege[field] === pathsString);

    node = root;

    paths.map((path) => {
      tempPathsArray = tempPathsArray.concat(path);

      if (!node.privileges) {
        node.privileges = {};
      }

      next = node.privileges[path];

      if (!next) {
        const tempPathsString = tempPathsArray.join('.');

        next =
          tempPathsString === pathsString
            ? (node.privileges[path] = {
                name: foundPrivilege.name,
                id: foundPrivilege.id,
                description: foundPrivilege.description,
                path: tempPathsString,
                displayPath: foundPrivilege.displayPath,
                checked: false,
              })
            : (node.privileges[path] = {
                name: path,
                path: tempPathsString,
                checked: false,
              });
      }
      node = next;
      return path;
    });
    return paths;
  });

  return root;
}

export default {
  transformPrivileges,
  createTree,
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/logic/helpers.js